import logoFull from '../../assets/images/logo.png';

import { Container, Content } from './styles';

interface Props {
  title: string;
}

function Header({ title }: Props) {
  return (
    <Container>
      <Content>
        <img src={logoFull} alt="OABRJ" />
        <h1>{title}</h1>
      </Content>
    </Container>
  );
}

export default Header;
